// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WithdrawalAccounts_container__zND-v {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
@media only screen and (max-width: 62.5em) {
  .WithdrawalAccounts_container__zND-v {
    grid-template-columns: 1fr;
  }
}
.WithdrawalAccounts_container_card__9hPBW {
  color: var(--color-dark);
  background-color: var(--color-light);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  border-radius: 2rem;
  margin: 2rem;
  padding: 2rem;
}
.WithdrawalAccounts_container_item__tAHww {
  display: flex;
  justify-content: space-between;
  gap: 4rem;
}
.WithdrawalAccounts_container_item__title__LfCOE {
  font-size: medium;
  width: 100%;
  margin: 0.5rem;
}
.WithdrawalAccounts_container_item__text__Dmiu9 {
  font-size: large;
  text-align: left;
  margin: 0.5rem;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/WithdrawalAccounts/WithdrawalAccounts.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,8BAAA;AADF;AAEE;EAHF;IAII,0BAAA;EACF;AACF;AACE;EACE,wBAAA;EACA,oCAAA;EACA,4CAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AACJ;AAEE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAAJ;AAEI;EACE,iBAAA;EACA,WAAA;EACA,cAAA;AAAN;AAEI;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AAAN","sourcesContent":["@import \"../variables/breakpoints\";\n\n.container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  @media only screen and (max-width: $bp-1000) {\n    grid-template-columns: 1fr;\n  }\n\n  &_card {\n    color: var(--color-dark);\n    background-color: var(--color-light);\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    border-radius: 2rem;\n    margin: 2rem;\n    padding: 2rem;\n  }\n\n  &_item {\n    display: flex;\n    justify-content: space-between;\n    gap: 4rem;\n\n    &__title {\n      font-size: medium;\n      width: 100%;\n      margin: 0.5rem;\n    }\n    &__text {\n      font-size: large;\n      text-align: left;\n      margin: 0.5rem;\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WithdrawalAccounts_container__zND-v`,
	"container_card": `WithdrawalAccounts_container_card__9hPBW`,
	"container_item": `WithdrawalAccounts_container_item__tAHww`,
	"container_item__title": `WithdrawalAccounts_container_item__title__LfCOE`,
	"container_item__text": `WithdrawalAccounts_container_item__text__Dmiu9`
};
export default ___CSS_LOADER_EXPORT___;
